{
  "version": 1,
  "asset_id": "f4f645ab-332a-4bd7-af1e-70a74efa32c2",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/f4f645ab-332a-4bd7-af1e-70a74efa32c2/southend-drone-poster-1280.webp",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/f4f645ab-332a-4bd7-af1e-70a74efa32c2/southend-drone-poster-1280.webp",
  "original_filename": "southend-drone-poster-1280.webp",
  "size": 116766,
  "content_type": "image/webp",
  "created_at": "2026-07-22T22:52:51Z"
}
